module.exports = __webpack_public_path__ + "img/ruanbao7.582c545d.jpg";